/* ===== Iberic Deco · Wishlist (favoritos) · sin app · localStorage ===== */
(function () {
  'use strict';
  if (window.__ibericWishlistLoaded) return;
  window.__ibericWishlistLoaded = true;

  var KEY = 'iberic:wishlist:v1';
  var PAGE_PATH = '/pages/favoritos';
  var HEART = '<svg class="iw-heart" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5 4.6 13a4.6 4.6 0 0 1 6.5-6.5l.9.9.9-.9A4.6 4.6 0 1 1 19.4 13z"/></svg>';

  /* ---------- almacenamiento ---------- */
  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    updateCounts();
    document.dispatchEvent(new CustomEvent('iberic:wishlist:changed'));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read(); var i = list.indexOf(handle); var added;
    if (i === -1) { list.push(handle); added = true; } else { list.splice(i, 1); added = false; }
    write(list); return added;
  }
  function removeItem(handle) { var list = read(); var i = list.indexOf(handle); if (i !== -1) { list.splice(i, 1); write(list); } }
  function count() { return read().length; }

  /* ---------- utilidades ---------- */
  function handleFromHref(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([a-zA-Z0-9\-_%]+)/);
    return m ? decodeURIComponent(m[1].split('?')[0].split('#')[0]) : null;
  }
  function currentProductHandle() {
    var c = document.querySelector('link[rel="canonical"]');
    if (c && /\/products\//.test(c.href)) return handleFromHref(c.href);
    if (/\/products\//.test(location.pathname)) return handleFromHref(location.pathname);
    return null;
  }
  function money(cents) {
    try { return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }
  function imgUrl(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function toast(msg) {
    var t = document.getElementById('iberic-wish-toast');
    if (!t) { t = document.createElement('div'); t.id = 'iberic-wish-toast'; t.className = 'iberic-wish-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 1900);
  }

  /* ---------- estado visual ---------- */
  function syncButtons(handle) {
    var wished = has(handle);
    var sel = '[data-iw-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]';
    document.querySelectorAll(sel).forEach(function (btn) {
      btn.classList.toggle('is-wished', wished);
      btn.setAttribute('aria-pressed', wished ? 'true' : 'false');
      var lbl = btn.querySelector('.iw-label'); if (lbl) lbl.textContent = wished ? 'En tus favoritos' : 'Añadir a favoritos';
    });
  }
  function updateCounts() {
    var n = count();
    document.querySelectorAll('.iberic-wish-head').forEach(function (h) {
      h.classList.toggle('has-items', n > 0);
      var b = h.querySelector('.iberic-wish-count'); if (b) b.textContent = n;
    });
  }

  function makeButton(handle, cls) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = cls; b.setAttribute('data-iw-handle', handle);
    b.setAttribute('aria-label', 'Añadir a favoritos');
    b.setAttribute('aria-pressed', has(handle) ? 'true' : 'false');
    if (has(handle)) b.classList.add('is-wished');
    b.innerHTML = HEART;
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var added = toggle(handle);
      syncButtons(handle);
      b.classList.remove('iw-animate'); void b.offsetWidth; b.classList.add('iw-animate');
      toast(added ? '❤️ Añadido a favoritos' : 'Quitado de favoritos');
    });
    return b;
  }

  /* ---------- inyecciones (idempotentes) ---------- */
  function injectCards() {
    document.querySelectorAll('.product-card').forEach(function (card) {
      if (card.hasAttribute('data-iw-done')) return;
      var link = card.querySelector('.product-card__link, a[href*="/products/"]');
      var handle = link ? handleFromHref(link.getAttribute('href')) : null;
      if (!handle) return;
      card.setAttribute('data-iw-done', '1');
      card.appendChild(makeButton(handle, 'iberic-wish-btn'));
    });
  }
  function injectPDP() {
    var handle = currentProductHandle();
    if (!handle || document.querySelector('.iberic-wish-pdp')) return;
    var buy = document.querySelector('.buy-buttons-block') || document.querySelector('form[action*="/cart/add"]');
    if (!buy) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'iberic-wish-pdp' + (has(handle) ? ' is-wished' : '');
    btn.setAttribute('data-iw-handle', handle);
    btn.innerHTML = HEART + '<span class="iw-label">' + (has(handle) ? 'En tus favoritos' : 'Añadir a favoritos') + '</span>';
    btn.addEventListener('click', function () {
      var added = toggle(handle);
      syncButtons(handle);
      toast(added ? '❤️ Añadido a favoritos' : 'Quitado de favoritos');
    });
    buy.parentNode.insertBefore(btn, buy.nextSibling);
  }
  function injectHeader() {
    document.querySelectorAll('.header-actions__cart-icon').forEach(function (cart) {
      var host = cart.parentNode;
      if (!host || host.querySelector('.iberic-wish-head')) return;
      var a = document.createElement('a');
      a.className = 'iberic-wish-head'; a.href = PAGE_PATH;
      a.setAttribute('aria-label', 'Ver favoritos');
      a.innerHTML = HEART + '<span class="iberic-wish-count">0</span>';
      host.insertBefore(a, cart);
    });
    updateCounts();
  }
  function inject() { injectCards(); injectHeader(); injectPDP(); }

  /* ---------- página de favoritos ---------- */
  function onFavoritesPage() { return location.pathname.replace(/\/$/, '').indexOf('/favoritos') !== -1; }
  function ensurePageContainer() {
    if (document.getElementById('iberic-wishlist')) return true;
    if (!onFavoritesPage()) return false;
    var main = document.querySelector('main, #MainContent, [role="main"]') || document.body;
    var box = document.createElement('div'); box.id = 'iberic-wishlist'; main.appendChild(box);
    return true;
  }
  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function addToCart(variantId, btn) {
    if (!variantId) return;
    var old = btn.textContent; btn.disabled = true; btn.textContent = 'Añadiendo...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function () { btn.textContent = '✓ Añadido'; toast('Añadido al carrito'); document.dispatchEvent(new CustomEvent('cart:refresh')); setTimeout(function () { btn.disabled = false; btn.textContent = old; }, 1600); })
      .catch(function () { btn.disabled = false; btn.textContent = old; });
  }
  var renderToken = 0;
  function renderPage() {
    var box = document.getElementById('iberic-wishlist');
    if (!box) return;
    var mine = ++renderToken;
    box.classList.add('iberic-wl-wrap');
    var list = read();
    if (!list.length) {
      box.innerHTML = '<div class="iberic-wl-empty"><h1 class="iberic-wl-title">Tus favoritos</h1><p>Aún no has guardado ningún producto. Pulsa el corazón ❤️ en cualquier producto para guardarlo aquí.</p><a href="/collections/all">Ver productos</a></div>';
      return;
    }
    box.innerHTML = '<h1 class="iberic-wl-title">Tus favoritos</h1><p class="iberic-wl-sub">' + list.length + (list.length === 1 ? ' producto guardado' : ' productos guardados') + '</p><div class="iberic-wl-grid" id="iberic-wl-grid"></div>';
    var grid = box.querySelector('#iberic-wl-grid');
    list.forEach(function (handle) {
      fetchProduct(handle).then(function (p) {
        if (mine !== renderToken) return;
        if (!p) { removeItem(handle); return; }
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        var src = imgUrl(p.featured_image || (p.images && p.images[0]) || '', 420);
        var card = document.createElement('div');
        card.className = 'iberic-wl-card';
        card.innerHTML =
          '<div class="iberic-wl-card__imgwrap">' +
            (src ? '<a href="/products/' + handle + '"><img src="' + src + '" alt="' + (p.title || '') + '"></a>' : '') +
            '<button class="iberic-wl-remove" type="button" aria-label="Quitar de favoritos">×</button>' +
          '</div>' +
          '<div class="iberic-wl-card__body">' +
            '<a class="iberic-wl-card__title" href="/products/' + handle + '">' + (p.title || '') + '</a>' +
            '<div class="iberic-wl-card__price">' + (v ? money(v.price) : money(p.price)) + '</div>' +
            (v ? '<button class="iberic-wl-add" type="button" data-vid="' + v.id + '">Añadir al carrito</button>' : '') +
          '</div>';
        card.querySelector('.iberic-wl-remove').addEventListener('click', function () { removeItem(handle); syncButtons(handle); });
        var addBtn = card.querySelector('.iberic-wl-add');
        if (addBtn) addBtn.addEventListener('click', function () { addToCart(parseInt(addBtn.getAttribute('data-vid'), 10), addBtn); });
        grid.appendChild(card);
      });
    });
  }

  /* ---------- arranque, observer y navegación ---------- */
  function boot() { inject(); if (ensurePageContainer()) renderPage(); }
  var raf;
  function schedule() { cancelAnimationFrame(raf); raf = requestAnimationFrame(inject); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.nodeType === 1 && t.closest && t.closest('#iberic-wishlist')) continue;
      if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
    }
  });
  try { obs.observe(document.body, { childList: true, subtree: true }); } catch (e) {}

  document.addEventListener('iberic:wishlist:changed', function () {
    if (document.getElementById('iberic-wishlist')) renderPage();
  });

  ['shopify:section:load', 'page:load', 'page:change', 'pageshow', 'popstate'].forEach(function (ev) {
    (ev === 'popstate' || ev === 'pageshow' ? window : document).addEventListener(ev, function () {
      schedule();
      if (ensurePageContainer()) renderPage();
    });
  });
})();
